import React from 'react';
import { Card, Button, Form, Container } from 'react-bootstrap';
import logoEs from '../../assets/myReportin-canal-de-denuncias.png';
import logoCa from '../../assets/myreportin_catalan_positivo.png';
import logoEu from '../../assets/myreportin_euskera_positivo.png';
import logoGa from '../../assets/myreportin_gallego_positivo.png';
import logoEn from '../../assets/myreportin_ingles_positivo.png';
import logoIt from '../../assets/myreportin_italiano_positivo.png';
import { FaArrowRightToBracket, FaArrowsRotate, FaRegEye, FaRegEyeSlash } from 'react-icons/fa6'
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";


const logos = {
  es: logoEs,
  ca: logoCa,
  eu: logoEu,
  ga: logoGa,
  en: logoEn,
  it: logoIt,
};

const SquareCard = ({ buttonText, onSubmit, showLogin, showSetPassword, setEmail, setPassword, setRepeatPassword, type, loading, error, errorMessage }) => {
  const [t, i18n] = useTranslation("login")
  const currentLanguage = i18n.language;

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);


  const toggleShowPassword = () => {
    setShowPassword(prevShowPassword => !prevShowPassword);
  };
  const handleRecoveryClick = () => {
    navigate("/reset-password"); // Cambia esto por la ruta real a tu pantalla de recuperación de contraseña
  };

  return (
    <div >
      <Container className="login-card ">
        <Card className="mx-auto  p-3 width-35 rounded-border-px custom-shadow">
          <Card.Body className="d-flex flex-column align-items-center">
            <img
              src={logos[currentLanguage] || logoEs}
              alt="Logo"
              className="d-block card-logo mb-3 mt-0"
            />

            <Form className="w-100">

              {type !== 'set-password' ?

                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>{t("loginCard.mail")}</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={`${t("loginCard.mail")}`}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-text-input"
                  />
                </Form.Group>

                :
                null
              }


              {showLogin && (
                <Form.Group controlId="formBasicPassword" className="mb-3">
                  <Form.Label>{t("loginCard.pass")}</Form.Label>
                  <div className="form-control-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder={`${t("loginCard.pass")}`}
                      onChange={(e) => setPassword(e.target.value)}
                      className="form-text-input"
                    />
                    {showPassword ?
                      <FaRegEyeSlash className="eye-icon" onClick={toggleShowPassword} />
                      :
                      <FaRegEye className="eye-icon" onClick={toggleShowPassword} />
                    }
                  </div>
                  <div className="mt-3">
                    <span onClick={handleRecoveryClick} className="custom-secondary-link">
                      {t("loginCard.resetPass")}
                    </span>
                  </div>
                </Form.Group>
              )}

              {showSetPassword && (<>
                <Form.Group controlId="formComplexSetPassword" className="mb-3">
                  <Form.Label>{t("setPassCard.pass")}</Form.Label>
                  <div className="form-control-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder={`${t("setPassCard.pass")}`}
                      onChange={(e) => setPassword(e.target.value)}
                      className="form-text-input"
                    />
                    {showPassword ?
                      <FaRegEyeSlash className="eye-icon" onClick={toggleShowPassword} />
                      :
                      <FaRegEye className="eye-icon" onClick={toggleShowPassword} />
                    }
                  </div>
                </Form.Group>

                <Form.Group controlId="formComplexRespeatPassword" className="mb-3">
                  <Form.Label>{t("setPassCard.repeatPass")}</Form.Label>
                  <div className="form-control-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder={`${t("setPassCard.repeatPass")}`}
                      onChange={(e) => setRepeatPassword(e.target.value)}
                      className="form-text-input"
                    />
                    {showPassword ?
                      <FaRegEyeSlash className="eye-icon" onClick={toggleShowPassword} />
                      :
                      <FaRegEye className="eye-icon" onClick={toggleShowPassword} />
                    }
                  </div>
                  <span className='form-card-input-error-text'>{error ? errorMessage : null}</span>
                </Form.Group>
              </>
              )}


              <div className="text-center mt-auto">
                <Button type="submit" onClick={onSubmit} className='w-100 mt-4 background-gradient font-color-white custom-shadow login-button' >
                  {
                    loading ?
                      <Spinner animation="border" className="spinner" />
                      :
                      <>
                        {
                          type === 'login' ?
                            <FaArrowRightToBracket className="mr-2" />
                            :
                            type === 'reset-password' || type === 'set-password' ?
                              <FaArrowsRotate className="mr-2" />
                              :
                              null
                        }
                        {buttonText}
                      </>
                  }
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default SquareCard;
